import React from 'react';

function ViewCoupon({ coupan, closeModal }) {
    if (!coupan) return null;

    function formatDateTime(isoString) {
        if (!isoString) return '-';
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    function formatDateTimeFull(isoString) {
        if (!isoString) return '-';
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    return (
        <div className="modal fade viewbox edit-box show d-block" id="couponModal" tabIndex={-1} aria-labelledby="couponModal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="couponModal">Coupon Details</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body px-5">
                        {/* Basic Information */}
                        <div className="d-box mt-3 pt-1">
                            <h3 className="service-heading" style={{ marginBottom: '10px' }}>Basic Information</h3>
                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                                <li className="w-50 mb-3">
                                    <span>Coupon Name: </span>
                                    <strong>{coupan?.name || '-'}</strong>
                                </li>
                                <li className="w-50 mb-3">
                                    <span>Status: </span>
                                    <strong>
                                        <span className={`badge ${coupan?.status === 'Active' ? 'bg-success text-white' : 'bg-danger text-white'}`}>
                                            {coupan?.status || '-'}
                                        </span>
                                    </strong>
                                </li>
                                <li className="w-100 mb-3">
                                    <span>Description: </span>
                                    <strong>{coupan?.description || '-'}</strong>
                                </li>
                                <li className="w-100 mb-3">
                                    <span>Sequence: </span>
                                    <strong>{coupan?.sequence || '-'}</strong>
                                </li>
                                <li className="w-100 mb-3">
                                    <span>Actual Price: </span>
                                    <strong>{coupan?.actualPrice}</strong>
                                </li>
                                <li className="w-100 mb-3">
                                    <span>Discount Price: </span>
                                    <strong>{coupan?.discountPrice}</strong>
                                </li>
                            </ul>
                        </div>

                        {/* Category & Vendor Details */}
                        <div className="d-box mt-4 pt-1">
                            <h3 className="service-heading" style={{ marginBottom: '10px' }}>Category & Vendor Details</h3>
                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                                <li className="w-50 mb-3">
                                    <span>Category: </span>
                                    <strong>{coupan?.categoryId?.name || '-'}</strong>
                                </li>
                                <li className="w-50 mb-3">
                                    <span>Vendor: </span>
                                    <strong>{coupan?.vendorId?.name || coupan?.vendorId?.businessName || '-'}</strong>
                                </li>
                                <li className="w-50 mb-3">
                                    <span>Service: </span>
                                    <strong>{coupan?.serviceId?.title || coupan?.serviceId?.name || '-'}</strong>
                                </li>
                            </ul>
                        </div>

                        {/* Discount Details */}
                        <div className="d-box mt-4 pt-1">
                            <h3 className="service-heading" style={{ marginBottom: '10px' }}>Discount Details</h3>
                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                                <li className="w-50 mb-3">
                                    <span>Discount Value: </span>
                                    <strong>{coupan?.upto || 0}%</strong>
                                </li>
                                <li className="w-50 mb-3">
                                    <span>Minimum Order Value: </span>
                                    <strong>₹{coupan?.price || 0}</strong>
                                </li>
                                <li className="w-50 mb-3">
                                    <span>Maximum Discount Amount: </span>
                                    <strong>₹{coupan?.maxDiscountAmount || 0}</strong>
                                </li>
                            </ul>
                        </div>
                        <div className="d-box mt-4 pt-1">
                            <h3 className="service-heading" style={{ marginBottom: '10px' }}>Usage Limits</h3>
                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                                <li className="w-50 mb-3">
                                    <span>Total Number of Coupons: </span>
                                    <strong>{coupan?.numberOfCoupons || coupan?.totalnumberOfusagesCoupons || 0}</strong>
                                </li>
                                <li className="w-50 mb-3">
                                    <span>Usage Limit Per User: </span>
                                    <strong>{coupan?.totalnumberOfusagesperuserCoupons || 0}</strong>
                                </li>
                                <li className="w-50 mb-3">
                                    <span>Current Usage Count: </span>
                                    <strong>{coupan?.coupanCounter || 0}</strong>
                                </li>
                            </ul>
                        </div>
                        <div className="d-box mt-4 pt-1">
                            <h3 className="service-heading" style={{ marginBottom: '10px' }}>Date Information</h3>
                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                                <li className="w-50 mb-3">
                                    <span>Expire Date: </span>
                                    <strong>{formatDateTime(coupan?.endDate)}</strong>
                                </li>
                                <li className="w-50 mb-3">
                                    <span>Created Date: </span>
                                    <strong>{formatDateTimeFull(coupan?.createdAt)}</strong>
                                </li>
                            </ul>
                        </div>
                        {coupan?.image && (
                            <div className="d-box mt-4 pt-1">
                                <h3 className="service-heading" style={{ marginBottom: '10px' }}>
                                    Coupon Image:
                                </h3>

                                <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                                    <li>     
                                        <div>
                                            <img
                                                src={
                                                    typeof coupan.image === "string"
                                                        ? `${process.env.REACT_APP_URL}${coupan.image}`
                                                        : `${process.env.REACT_APP_URL}${coupan.image?.url}`
                                                }
                                                alt="Coupon"
                                                style={{
                                                    width: "150px",
                                                    height: "150px",
                                                    objectFit: "cover",
                                                    borderRadius: "8px",
                                                    border: "1px solid #ccc"
                                                }}
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        )}

                        {/* Terms & Conditions */}
                        {coupan?.termsAndConditions && (
                            <div className="d-box mt-4 pt-1">
                                <h3 className="service-heading" style={{ marginBottom: '10px' }}>Terms & Conditions</h3>
                                <div className="terms-conditions-box p-3 bg-light rounded" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                                        {coupan?.termsAndConditions}
                                    </p>
                                </div>
                            </div>
                        )}


                    </div>



                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={closeModal}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewCoupon;